import { useMemo } from 'react'

import { useCompletedOrder } from 'public/components/online_ordering/OrderContext'

import {
  getCompletedOrderFreeDeliveryAmount,
  getFundedOfferPaymentGuids,
  isFreeDeliveryToastFundedOffer,
  isFundedOfferInTotal
} from './appliedFundedOffers'

// The completed order counterpart to useAppliedFreeDelivery, which reads the cart.
// Deliberately not channel-gated the way the cart hooks are: one order's receipt is
// reachable from the Toast app, from order.toasttab.com (the digital receipt email
// links there) and from the restaurant's own domain, and the guest was charged the
// same amount whichever one they open. The gate governs advertising an available
// offer, not describing one that was already applied.
export const useCompletedOrderFreeDelivery = () => {
  const { completedOrder } = useCompletedOrder()

  const offers = completedOrder?.appliedToastFundedOffers
  const payments = completedOrder?.payments

  return useMemo(() => {
    // Only free delivery is priced into the displayed total, so the gate reads the
    // same offers as the amount rather than trusting the two to move together.
    const freeDeliveryOffers = offers?.filter(isFreeDeliveryToastFundedOffer)

    return {
      amount: getCompletedOrderFreeDeliveryAmount(freeDeliveryOffers),
      // Matched by guid so it never string-matches a payment name.
      fundedOfferPaymentGuids: getFundedOfferPaymentGuids(offers),
      isFundedOfferInTotal: isFundedOfferInTotal(freeDeliveryOffers, payments)
    }
  }, [offers, payments])
}
